import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateCampaignId } from "../../redux/reducers/CampaignRightModalIdSlice";
import { getAxiosResponse,postAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import DataTable, { createTheme } from "react-data-table-component";
import CampaignStatusCountBlock from "./CampaignStatusCountBlock";
import { dateFormat } from "../../services/Util";
import Constants from "../../Constants";
import { RotatingLines } from "react-loader-spinner";
import CustomProgressBar from "../global/CustomProgressBar";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { useSearchParams, useNavigate} from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import DateFormat, {DATE_FORMATS} from "../../pages/DateFormat";
import { confirmAlert } from 'react-confirm-alert';

export default function CampaignTab({searchText}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translate = t;
  const [params ,setParams] =useSearchParams();
  const tag = params.get('tag'); 
  const buttonRef = useRef()
  const paginationRef = useRef();
  const [sortFocus, setsortFocus] = useState('');
  const customerBootstrapData = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value;
  const [pageRefresh, setPageRefresh] = useState(false);
  const navigate = useNavigate();

  const getPopupDetails = (row) => {
   const campaignId = (row.id);
    let popupTitle = Constants.BLANK;
    let popupMessage = (<></>);
    if (row.contextUserRequestedAccess===false) {
    const messageParams = {
        0: row.name,
        1: row.owner.firstName,
        2: row.owner.lastName
    };
      popupTitle = `${t('campaign_page.workspace_member_request_title')}`;
      const translatedText = t('campaign_page.workspace_member_request_text');
      const formattedText = translatedText.replace(/\{(\d+)\}/g, (match, index) => messageParams[index]);
      popupMessage = (
          <p>
              {formattedText}
          </p>
      );
      showRequestAlert({popupTitle, popupMessage,rowId: row.id});
      document.body.classList.remove("modal-open");
      }
  else {
      popupTitle = `${t('campaign_page.requested_title')}`;
      popupMessage = <p>{t('campaign_page.requested_text')}</p>;
      showInProgressAlert({popupTitle, popupMessage,rowId: row.id});
      document.body.classList.remove("modal-open");

  }
}

  const showRequestAlert = (popupDetails) => {
		confirmAlert({
			title: popupDetails?.popupTitle,
			message: popupDetails?.popupMessage, 
			buttons: [
			  {
				label: `${t('request_access')}`,
        onClick: () => handleRequestAccess(popupDetails.rowId),
				onKeyDown : (e) => {
					if(e.key === Constants.TAB){
					  if(e.shiftKey === true){
						e.preventDefault()
					  }
					}
				  }
			  },
			  {
				label: `${t('button_cancel')}`,
				onKeyDown : (e) => {
					if(e.key === Constants.TAB){
					  if(e.shiftKey === false){
						e.preventDefault() 
					  }
					}
				  }
			  }
			],
			closeOnEscape: true,
			closeOnClickOutside: false,
			overlayClassName: "delete_overlay"
		  });
	}

  const showInProgressAlert = (popupDetails) => {
		confirmAlert({
			title: popupDetails?.popupTitle,
			message: popupDetails?.popupMessage, 
      buttons: [
        {
            label: `${t('button_cancel')}`,
            
        }
    ],
			closeOnEscape: true,
			closeOnClickOutside: false,
			overlayClassName: "delete_overlay"
		  });
	}

  function showRightModel() {
    const isStatusClicked = $(document.activeElement).closest('[id*="campaign.progress"]').length > 0;
    const isReviewClicked = $(document.activeElement).parent().is('[id*="project.review"]');
    const isTranslationClicked = $(document.activeElement).parent().is('[id*="project.transition"]');
    const isBiddingClicked = $(document.activeElement).parent().is('[id*="project.bidding"]');
    if (isStatusClicked || isReviewClicked || isTranslationClicked || isBiddingClicked) {
      $(document.activeElement).addClass('focusStatus');
    }
    document.body.classList.add("modal-open");
  }

  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";
  const customStyles = {
    table: {
      style: {
        textAlign: "center",
        fontFamily: "Poppins",
        color: aaaSelected ? "#FFF" : "#706F6F",
        backgroundColor: aaaSelected ? "#000" : "#fff",
      },
    },
    head: {
      style: {
        fontSize: "85.71429%",
        fontWeight: 600,
        lineHeight: 1.5,
        color: aaaSelected ? "#AEAEAE" : "#706F6F",
        verticalAlign: "bottom",
        padding: "0 16px 5px",
        whiteSpace: "nowrap",
        backgroundColor: aaaSelected ? "#000" : "#fff",
      },
    },
    headRow: {
      style: {
        borderBottom: "none", // override the row height
        margin: "10px 0",
        // backgroundColor: aaaSelected ?"#000":"#fff",
      },
    },
    rows: {
      style: {
        fontSize: "14px",
        fontWeight: 400,
        color: aaaSelected ? "#AEAEAE" : "#706F6F",
        textAlign: "center",
        minHeight: "48px",
        "&:not(:last-of-type)": {
          borderBottom: "none", // override the row height
          margin: "10px 0",
        },
      },
    },
    headCells: {
      style: {
        backgroundColor: aaaSelected ? "#000" : "#fff",
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        textAlign: "center",
        paddingLeft: "18px", // override the cell padding for data cells
        paddingRight: "8px",
        fontWeight: 500,
        fontSize: "100%",
        color: aaaSelected ? "#FFF" : "#4D4D4D",
        padding: "9px 16px",
      },
    },
  };

  const handleRequestAccess = (rowId) => {
  const campaignId = parseInt(rowId);
        const requestUrl = APIUrls.CAMPAIGN_MEMBER_REQUEST(campaignId);
           postAxiosResponse(requestUrl, null)
           .then(()=>
           {
            setPageRefresh(true)
           })
    .catch((err) => {
      console.error(err);
    });
  }

  const conditionalRowStyles = [
    {
      when: (row) => row.status === "CREATED",
      classNames: ["campaign-table-list", "default-column"],
    },
    {
      when: (row) => row.status === "IN_PROGRESS",
      classNames: ["campaign-table-list", "warning-column"],
    },
    {
      classNames: ["campaign-table-list", "success-column"],
      when: (row) => row.status === "COMPLETED",
    },
    {
      classNames: ["campaign-table-list", "default-column"],
      when: (row) => row.status === "CANCELLED",
    },{
      classNames: ["campaign-table-list", "default-column"],
      when: (row) => row.status === "CLOSED",
    },
  ];
  const addReviewCount = (counts) => {
    if(counts === ''){
return ''
    }
    var totalCount = 0;
    counts.map((count) => {
      totalCount += count.count;
    });
    return totalCount;
  };
  
  const rowClicked = (row) => {
    if (row.editableByContextUser === true || customerBootstrapData?.permissions.UPDATE_UNOWNED_WORKSPACES) {
      buttonRef.current = 'row-' + row.id + ' a';
      dispatch(updateCampaignId(row.id));
      showRightModel();
    } else {
      getPopupDetails(row);
    }
  };

  const handlingRowClicked = (event, row) => {
    if (event.key===Constants.ENTER) {
      rowClicked(row);
    }
  };
  
  const columns = [
    {
      id: "workspace.name",
      name: `${translate("campaign_page.campaign_name")}`,
      minWidth: "350px",
      selector: (row) => row.name,
      sortable: true,
      style:{textAlign:"left"},
      cell: (row) => (
        <div onClick={() => {
            if (row.editableByContextUser===true || customerBootstrapData?.permissions.UPDATE_UNOWNED_WORKSPACES) {
              navigate(`/campaign/${row.id}`);
           }
           else {
            getPopupDetails(row);
            }
        }}>
          
          <Link
            className="campaign-title"
            campaign-tour="datatable-title"
            style={{
              color: aaaSelected ? "#FFF" : "#4067D6",
              fontWeight: 500,
              position: "relative",
            }}
          >
            {row.name}
          </Link>
        </div>
      ),
    },
    {
      id: "workspace.progress",
      name: `${translate("campaign_page.campaign_progress")}`,
      selector: (row) => row.progress,
      cell: (row) => (
        <div
          aria-label={row.progress}
          className="font-bold"
        >
          <CustomProgressBar
            completed={row.progress !== "" ? row.progress : 0}
            labelSize="14px"
            labelLineHeight="0px"
            width="90px"
            labelClassName="progressBarLabel"
            borderRadius="50px"
            labelAlignment="outside"
            labelColor="#4D4D4D"
            customLabel=""
            height="10px"
            className=""
            bgColor={aaaSelected ? row.progress < 100 ? "#ffb066" : "#c0ff61"  : row.progress < 100 ? "#FF7D04":"#04AD7A"}
            baseBgColor="#E6E6E6"
          />
        </div>
      ),
    },
    {
      id: "project.review",
      name: `${translate("campaign_page.in_review")}`,
      maxWidth: "10px",
      wrap: true,
      right: true,
      selector: (row) => row.projectStatusCount.inReview,
      cell: (row) => (
        <div
          tabIndex={0}
          aria-label={"in review count " + row.projectStatusCount.inReview}
          className="font-bold"
          onClick={() => rowClicked(row)}
          onKeyDown={(e)=> handlingRowClicked(e, row)}
        >
          <span className="table-circle" onClick={() => rowClicked(row)}>
            {row.projectStatusCount.inReview}
          </span>
        </div>
      ),
    },
    {
      id: "project.transition",
      name: `${translate("campaign_page.in_translation")}`,
      maxWidth: "10px",
      wrap: true,
      center: true,
      selector: (row) => row.projectStatusCount.inReview.inTranslation,
      cell: (row) => (
        <div
          tabIndex={0}
          aria-label={"in translation count " + row.projectStatusCount.inTranslation}
          className="font-bold"
          onClick={() => rowClicked(row)}
          onKeyDown={(e)=> handlingRowClicked(e, row)}
        >
          <span className="table-circle green" onClick={() => rowClicked(row)}>
            {row.projectStatusCount.inTranslation}
          </span>
        </div>
      ),
    },
    {
      id: "project.bidding",
      name: `${translate("campaign_page.in_bidding")}`,
      maxWidth: "10px",
      wrap: true,
      left: true,
      selector: (row) => row.projectStatusCount.inBidding,
      cell: (row) => (
        <div
          tabIndex={0}
          aria-label={"in quoting count " + row.projectStatusCount.inBidding}
          className="font-bold"
          onClick={() => rowClicked(row)}
          onKeyDown={(e)=> handlingRowClicked(e, row)}
        >
          <span className="table-circle purple" onClick={() => rowClicked(row)}>
            {row.projectStatusCount.inBidding}
          </span>
        </div>
      ),
    },
    {
      id: "workspace.num_completed_projects",
      name: `${translate("campaign_page.project_completed")}`,
      center: true,
      selector: (row) => row.projectContentTypeDisplay,
      cell: (row) => (
        <div
          tabIndex={-1}
          aria-label={
            "completed " +
            row.projectSummaryInfo?.projectsCompleted +
            " of " +
            row.projectSummaryInfo?.totalProjects
          }
          className="font-bold"
          onClick={() => rowClicked(row)}
        >
          {row.projectSummaryInfo?.projectsCompleted} of{" "}
          {row.projectSummaryInfo?.totalProjects}
        </div>
      ),
    },
    {
      id: "workspace.num_alerts",
      name: `${translate("campaign_page.alerts")}`,
      maxWidth: "10px",
      selector: (row) => row.projectSummaryInfo?.openAlerts,
      cell: (row) => (
        <div
          className="flex-center"
          tabIndex={-1}
          aria-label={"alert " + row.projectSummaryInfo?.openAlerts}
          onClick={() => rowClicked(row)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
              stroke="#F04067"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M7 4.59985V6.99985"
              stroke="#F04067"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M7 9.40015H7.00709"
              stroke="#F04067"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </svg>
          <span style={{ marginLeft: "4px" }}>
            {row.projectSummaryInfo?.openAlerts}
          </span>
        </div>
      ),
    },
    {
      id: "workspaceDate.date",
      name: `${translate("campaign_page.due_date")}`,
      left: true,
      selector: (row) => row.dueDate,
      sortable: true,
      cell: (row) => (
        <div tabIndex={-1} onClick={() => rowClicked(row)}>
           <DateFormat date={row.dueDate}/>
        </div>
      ),
    },
    {
      id: "workspace.openReviews",
      name: `${translate("campaign_page.open_reviews")}`,
      selector: (row) => row.userAndCountResources,
      sortable: false,
      cell: (row) => (
        <div
          tabIndex={-1}
          aria-label={row.status.display}
          onClick={() => rowClicked(row)}
        >
          {addReviewCount(row.userAndCountResources)}
        </div>
      ),
    },
  ];
	$(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    $('.rdt_Table').attr('aria-label', 'campaigns');
    $('.font-bold').on('keydown click', '.progressReport', function(e) {
      if (e.type === "click" || e.key === Constants.ENTER) {
        const row = {
          id: $(this).closest('.rdt_TableRow').attr('id').match(/\d+/)[0]
        }
        rowClicked(row);
      }
    });
   })
  const [pending, setPending] = useState(true);
  const [campaignListDate, setCampaignListData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState("");
  const SelectTagRedux = useSelector(
    (updateCampaignTag) => updateCampaignTag.campaign_tag_filter
  ).value;
  const selectedStatusRedux = useSelector(
    (updateCampaignStatus) => updateCampaignStatus.campaign_status_filter
  ).value;
  const selectedDeliveryStatusRedux = useSelector(
    (updateCampaignDeliveryStatus) =>
      updateCampaignDeliveryStatus.campaign_delivery_status_filter
  ).value;
  const memberOnlyStatusRedux = useSelector(
    (setMemberOnlyStatus) => setMemberOnlyStatus.campaign_member_only_filter
  ).value;

  const campaignOwnerFilterRedux = useSelector(
    (campaignOwnerFilterStatus) => campaignOwnerFilterStatus.campaign_owner_filter
  ).value;

  const queryParams = new URLSearchParams(window.location.search);


  const statusVal =
    selectedStatusRedux !== "" ? `&status=${selectedStatusRedux}` : "";
  const deliveryStatusVal =
    selectedDeliveryStatusRedux !== ""
      ? `&deliveryStatus=${selectedDeliveryStatusRedux}`
      : "";
  let tagString = "";
  SelectTagRedux?.map((tag) => {
    tagString += `&tag=${tag.value}`;
  });
  
  const searchVal =
    searchText !== "" ? `&name=${searchText}` : "";

  const debouncedSearchTerm = useDebounce(searchVal, 1000); // Adjust the delay as needed (e.g., 500ms)


  useEffect(() => {
    $.each($(".campaign_progress"), function (index, value) {
      $(value).attr("aria-label", $(value).find("span").text());
      //value.attr('aria-label', value.children[0].ariaLabel);
    });
    $(".rdt_TableRow").attr("campaign-tour","datatable-row");
  });
  const fetchCampaignData = async (page) => {
    setPending(true);
    if(tag===null){
    await getAxiosResponse(
      APIUrls.WORKSPACE_LIST +
        `?page=${page}&pageSize=${perPage}${sort}&campaignOwner=${campaignOwnerFilterRedux}&onlyMember=${memberOnlyStatusRedux}${debouncedSearchTerm}${statusVal}${queryParams.get('deliveryStatus') ?deliveryStatusVal:Constants.BLANK}${tagString}`
    )
      .then((res) => {
        if (res.data !== "") {
          const campaignData = res?.data?.data?.result;
          setCampaignListData(campaignData);
          setTotalRows(res?.data?.data?.resultCount);
          setPending(false);

          setTimeout(() => {
            if(sortFocus){
              $(".rdt_TableCol_Sortable[data-column-id='" + sortFocus + "']").trigger('focus');
              setsortFocus('');
            }
            if (paginationRef.current) {
                  $('#'+ paginationRef.current).trigger('focus');
                  paginationRef.current = '';
              }
            }, 300);

        }
      })
    setPending(false);
    }
  
  };

  const fetchCampaignDataOnTag = async (page) => {
    setPending(true);
    if(tag!==null){
    await getAxiosResponse(
      APIUrls.WORKSPACE_LIST +
        `?page=${page}&onlyMember=${memberOnlyStatusRedux}${statusVal}&tag=${tag}`
    )
      .then((res) => {
        if (res.data !== "") {
          setCampaignListData(res?.data?.data?.result);
          setTotalRows(res?.data?.data?.resultCount);
          setPending(false);
        }
      })
    }
    setPending(false);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPending(true);
    setPending(true);
    await getAxiosResponse(
      APIUrls.WORKSPACE_LIST +
        `?page=${page}&pageSize=${newPerPage}${sort}&campaignOwner=${campaignOwnerFilterRedux}&onlyMember=${memberOnlyStatusRedux}${searchVal}${statusVal}${deliveryStatusVal}${tagString}`
    )
      .then((res) => {
        if (res.data !== "") {
          setCampaignListData(res?.data?.data?.result);
          setPerPage(newPerPage);
          setPending(false);
          setTimeout(function(){
            $('.campaign-datatable-block').next().find('nav.rdt_Pagination select').trigger('focus');
          }, 100);
        }
      })
    setPending(false);
  };

  const handlePageChange = (paging) => {
    setPending(true);
    setCurrentPage(paging);
    if ($('#pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-previous-page').attr('id');
    } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };

  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
    .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
    var order = sortDirection.toUpperCase();
    var sortedColumn = column.id;
    setsortFocus(column.id)
    var sortedString = `&sortOrder=${order}&sortColumn=${sortedColumn}`;
    setSort(sortedString);
  };

  useEffect(() => {
    fetchCampaignData(currentPage);
  }, [
    currentPage,
    sort,
    statusVal,
    memberOnlyStatusRedux,
    deliveryStatusVal,
    campaignOwnerFilterRedux,
    tagString,
    debouncedSearchTerm
  ]);

  useEffect(()=>
  {
    if(pageRefresh)
    {
      fetchCampaignData(currentPage);
      setPageRefresh(false);
    }   
  },[pageRefresh]);

  useEffect(() => {
    fetchCampaignDataOnTag(currentPage);
  }, [tag]);

  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
      <div role="row" className="no-data-display align-center">
       <div role="cell">
        <i className="nodata-icon"></i>
        <p>{Constants.NO_RECORD_FOUND}</p>
      </div></div>
      </div>
    );
  };

  return (
    <>
      <div className="wrap-data">
        <CampaignStatusCountBlock />
        <div className="white-bg text-center">
          {pending ? (
            <RotatingLines
              strokeColor="grey"
              strokeWidth="5"
              width="96"
              visible={pending}
            />
          ) : (
            <div className="campaign-hedaing flex-center justify-center">
              <p>
                {translate("campaign_page.number_of_campaign")} :{" "}
                <strong>{campaignListDate?.length}</strong>
              </p>
              <div className="color-instruction flex-center">
                <ul className="flex-center">
                  <li>
                    <span className="default"></span>
                    {translate("campaign_page.created")}
                  </li>
                  <li>
                    <span className="warning"></span>
                    {translate("campaign_page.in_progress")}
                  </li>
                  <li>
                    <span className="success"></span>
                    {translate("campaign_page.completed")}
                  </li>
                </ul>
              </div>
            </div>
          )}
          <DataTable className="campaign-datatable-block"
            keyField="id"
            columns={columns}
            data={campaignListDate}
            theme={theme}
            conditionalRowStyles={conditionalRowStyles}
            sortServer
            responsive
            striped
            pagination
            onSort={handleSort}
            pointerOnHover={true}
            onRowClicked={(row, event) => {
              rowClicked(row);
            }}
            customStyles={customStyles}
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
            onChangePage={handlePageChange}
            progressPending={pending}
            noDataComponent={noDataFoundComponent()}
          />
        </div>
      </div>
    </>
  );
}
